import React from 'react';

export interface ColumnDef {
  key: string;
  label: string;
  sortable?: boolean;
  className?: string;
  minWidth?: string;
}

interface AdminTableHeaderProps {
  columns: ColumnDef[];
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  onSort?: (key: string) => void;
}

const AdminTableHeader: React.FC<AdminTableHeaderProps> = ({
  columns,
  sortBy,
  sortDirection = 'asc',
  onSort,
}) => {
  return (
    <thead className="bg-gray-200 text-gray-700">
      <tr>
        {columns.map((col) => (
          <th
            key={col.key}
            className={`py-2 text-left px-4 border-b text-sm ${col.sortable ? 'cursor-pointer select-none' : ''} ${col.className || ''}`}
            style={col.minWidth ? { minWidth: col.minWidth } : undefined}
            onClick={() => col.sortable && onSort?.(col.key)}
          >
            <span className="inline-flex items-center gap-1">
              {col.label}
              {col.sortable && (
                <span className="inline-block w-4">
                  {sortBy === col.key ? (
                    <img
                      src={sortDirection === 'asc' ? '/sort-up.svg' : '/sort-down.svg'}
                      alt="Sort"
                      className="w-4 h-4 inline"
                    />
                  ) : (
                    <span className="text-gray-300 text-xs">↕</span>
                  )}
                </span>
              )}
            </span>
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default AdminTableHeader;
